// extracted by mini-css-extract-plugin
module.exports = {"panGreen":"#30b08f"};